export default {
    TAGS_USER_NAME: "$user_name"
 
};